import trainerApply from '@/api/trainer_apply';
import { APPROVE_TRAINER_APPLY, FETCH_TRAINER_APPLIES, FETCH_TRAINER_APPLY, REJECT_TRAINER_APPLY } from './types';

export default {
    [FETCH_TRAINER_APPLIES]({ commit }) {
        return trainerApply
            .all()
            .then(resp => commit(FETCH_TRAINER_APPLIES, resp));
    },
    [FETCH_TRAINER_APPLY]({ commit }, payload) {
        return trainerApply
            .get(payload.id)
            .then(resp => commit(FETCH_TRAINER_APPLY, resp));
    },
    [REJECT_TRAINER_APPLY]({ commit }, payload) {
        return trainerApply
            .reject(payload.id)
            .then(resp => commit(FETCH_TRAINER_APPLY, resp));
    },
    [APPROVE_TRAINER_APPLY]({ commit }, payload) {
        return trainerApply
            .approve(payload.id)
            .then(resp => commit(APPROVE_TRAINER_APPLY, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/trainer_apply/actions.js